import { writable } from "svelte/store"

export const dialogStates = writable({
  LoginModal: false,
  RegisterModal: false,
  TransactionDetailsModal: false,
})

export const dialogData = writable({
  PaymentIqIframe: {},
  RolloverDetailsModal: {},
  WheelSpinModal: {},
  TransactionDetailsModal: {},
})

export function openDialog(dialogName: string, data: any = null) {
  console.log(`Opening dialog: ${dialogName}`, data)
  dialogStates.update((state: any) => {
    state[dialogName] = true
    return state
  })

  if (data !== null) {
    dialogData.update((currentData: any) => {
      currentData[dialogName] = data
      return currentData
    })
  }
}

export function closeDialog(dialogName: string) {
  console.log(`Closing dialog: ${dialogName}`)
  dialogStates.update((state: any) => {
    state[dialogName] = false
    return state
  })

  dialogData.update((currentData: any) => {
    currentData[dialogName] = {}
    return currentData
  })
}

